import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { Fragment, useContext } from "react";
import { Edit, Eye, Plus, Trash } from "react-feather";
import Switch from "react-js-switch";
import {
  Card,
  CardHeader,
  Col,
  Container,
  Form,
  Input,
  Row,
  Table,
} from "reactstrap";
import { MuiTabelStyle, SLIDER_MASTER } from "../../constant";
import SliderMasterContext from "../../context/SliderMasterContext/SliderMasterContext";
import DataNotFound from "../../DataNoteFound/DataNotFound";
import Breadcrumbs from "../../layout/breadcrumb";

const OrganizationItem = (props) => {
  const {
    editHandle,
    showHandle,
    sorting,
    switch_onChange_handle,
    AddModel,
    setPage,
    setPageSize,
    pageSize,
    page,
    record,
    deleteHandle,
  } = props;

  const { filter, formvalue, setFilter } = useContext(SliderMasterContext);

  const defaultColumns = [
    {
      flex: 0.1,
      minWidth: 100,
      field: "img",
      headerName: "Image",
      renderCell: (params) => <img src={params.row.image} alt="" width={200} />,
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "name",
      headerName: "Name",
      renderCell: (params) => params.row.name,
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: "isActive",
      headerName: "STATUS",
      renderCell: (params) => (
        <Switch
          value={params.row.isActive ? true : false}
          onChange={() =>
            switch_onChange_handle(params.row.sliderId, params.row.isActive)
          }
        />
      ),
    },
    {
      field: "actions",
      headerName: "ACTIONS",
      minWidth: 130,
      renderCell: (params) => (
        <>
          <button
            className="_edit"
            type="button"
            style={{
              background: "none",
              textDecoration: "none",
              border: "none",
              color: "#7366ff",
            }}
            onClick={() => editHandle(params.row.sliderId)}
          >
            <Edit style={{ width: "19px" }} />
          </button>
          <button
            className="_edit"
            type="button"
            style={{
              background: "none",
              textDecoration: "none",
              border: "none",
              color: "#7366ff",
            }}
            onClick={() => showHandle(params.row.sliderId)}
          >
            <Eye style={{ width: "19px" }} />
          </button>
          <button
            className="_edit"
            type="button"
            style={{
              background: "none",
              textDecoration: "none",
              border: "none",
              color: "red",
            }}
            onClick={() => deleteHandle(params.row.sliderId)}
          >
            <Trash style={{ width: "19px" }} />
          </button>
        </>
      ),
    },
  ];

  return (
    <Fragment>
      <Breadcrumbs parent={SLIDER_MASTER.PERENT} />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <h3>{SLIDER_MASTER.PERENT}</h3>
                <button
                  type="button"
                  style={{ border: "none", background: "none" }}
                  onClick={AddModel}
                >
                  <div
                    style={{
                      width: "50px",
                      background: "#7366ff",
                      borderRadius: "19rem",
                      color: "white",
                    }}
                  >
                    <h1>
                      <Plus />
                    </h1>
                  </div>
                </button>
              </CardHeader>
              <Table>
                <thead>
                  <tr>
                    <th>
                      <Row>
                        <Col md="2 mb-2">
                          <Form className="search-file">
                            <Input
                              className="form-control"
                              type="text"
                              placeholder="Image Name Search..."
                              value={filter}
                              onInput={(e) => setFilter(e.target.value)}
                              style={{
                                border: "1px solid #ecf3fa",
                                borderRadius: "8px",
                              }}
                            />
                          </Form>
                        </Col>
                      </Row>
                    </th>
                  </tr>
                </thead>
              </Table>
              <Box
                sx={{
                  "& .even": {
                    backgroundColor: "#f1f1f1",
                  },
                  "& .odd": {
                    backgroundColor: "white",
                  },
                }}
              >
                {formvalue.length && formvalue.length ? (
                  <>
                    <DataGrid
                      autoHeight
                      pagination
                      sx={MuiTabelStyle}
                      rows={formvalue}
                      rowCount={record}
                      pageSize={pageSize}
                      getRowId={(row) => row.sliderId}
                      columns={defaultColumns}
                      page={page - 1}
                      rowsPerPageOptions={[7, 10, 25, 50]}
                      onPageSizeChange={(newPageSize) =>
                        setPageSize(newPageSize)
                      }
                      onPageChange={(newPageNo) => setPage(newPageNo + 1)}
                      paginationMode="server"
                      disableSelectionOnClick
                      checkboxSelection={false}
                      sortingMode="server"
                      onSortModelChange={sorting}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "even"
                          : "odd"
                      }
                    />
                  </>
                ) : (
                  <DataNotFound />
                )}
              </Box>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default OrganizationItem;
